<div class="container all-celebrations-container">
  <app-dashboard-header
    *ngIf="user"
    [showSwitcher]="false"></app-dashboard-header>
  <div class="card border-0 p-3">
    <div
      class="tool position-absolute top-0 start-100 translate-middle rounded-circle fs-3"
      style="background-color: white; line-height: 1rem">
      <i
        [style.cursor]="'pointer'"
        routerLink="/dashboard"
        ngbTooltip="Close"
        class="bi bi-x-circle color-primary"></i>
    </div>
    <div class="text-center mt-2">
      <h2 class="fw-bold mb-0">Smart Feedback</h2>
    </div>
    <div class="card-body pt-0">
      <hr class="border border-tertiary border-1" />

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 6%">View</th>
              <th style="width: 30%">Feedback Request</th>
              <th style="width: 14%">Date</th>
              <th style="width: 30%">Competency</th>
              <th style="width: 20%">Skill Alignment</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!isLoading; else loadingTemplate">
              <ng-container *ngIf="tableData.length > 0; else noFeedback">
                <tr class="align-middle" *ngFor="let feedback of tableData">
                  <td>
                    <button
                      aria-label="View feedback"
                      ngbTooltip="View Feedback"
                      (click)="viewSmartFeedback(feedback.id)"
                      class="btn btn-link color-tertiary p-1">
                      <i class="bi bi-eye" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td class="text-truncate" style="max-width: 30%">
                    <div
                      class="d-flex align-items-start text-truncate"
                      *ngIf="feedback.attachment"
                      style="max-width: 100%">
                      <i
                        [ngClass]="[
                          'bi',
                          feedback.attachment.iconClass,
                          'color-tertiary',
                          'me-1'
                        ]"></i>
                      <button
                        type="button"
                        (click)="viewFile(feedback.attachment)"
                        class="btn btn-link p-0 text-truncate text-start"
                        style="color: #1272a6; max-width: 300px"
                        [attr.title]="feedback.attachment.name">
                        {{ feedback.attachment.name }}
                      </button>
                    </div>
                    <div class="text-truncate" style="max-width: 300px">
                      {{ feedback.full_request.submission }}
                    </div>
                  </td>
                  <td>
                    {{ feedback.created_at | formatDate }}<br />
                    {{ feedback.created_at | formatDate : "h:mm a" }}
                  </td>
                  <td>
                    <div class="text-muted fw-light">
                      {{ feedback.competencysRubric?.title }}
                    </div>
                    {{ feedback.competency?.title }}
                  </td>
                  <td>
                    <div
                      class="progress bg-neutral"
                      role="progressbar"
                      aria-label="Skill Alignment"
                      [attr.aria-valuenow]="feedback.grade"
                      aria-valuemin="0"
                      aria-valuemax="100">
                      <div
                        class="progress-bar bg-tertiary"
                        [ngStyle]="{ width: feedback.grade + '%' }"></div>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noFeedback>
                <tr class="border-bottom-0">
                  <td
                    colspan="5"
                    class="text-center align-middle p-0"
                    style="min-height: 30vh">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="min-height: 30vh">
                      <p class="text-body-secondary my-4">
                        No smart feedback found. Head to the
                        <a routerLink="/dashboard" href="/dashboard"
                          >dashboard</a
                        >
                        to get some feedback!
                      </p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div
      *ngIf="listMeta && listMeta.totalCount > listMeta.perPage"
      class="row mt-4">
      <div class="d-flex justify-content-center">
        <ngb-pagination
          [(page)]="listMeta.currentPage"
          [pageSize]="listMeta.perPage"
          [collectionSize]="listMeta.totalCount"
          (pageChange)="getSmartFeedback()"
          [maxSize]="5"
          [ellipses]="true"></ngb-pagination>
      </div>
    </div>

    <ng-template #loadingTemplate>
      <app-loader></app-loader>
    </ng-template>
  </div>
</div>
<app-modal
  #feedbackModal
  [modalConfig]="{
    titleText: 'Smart Feedback',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'custom-class',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="feedbackModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div *ngIf="currentFeedback">
    <div class="p-2">
      <ng-container *ngIf="currentFeedback.competency">
        <div class="mb-2">
          <div class="fw-800 mb-2">
            {{ currentFeedback.competency.title }}
          </div>
          <app-safehtml
            [html]="currentFeedback.full_request.expectation"></app-safehtml>
        </div>
      </ng-container>
      <ng-container *ngIf="currentFeedback.attachment">
        <div class="mb-4">
          <div class="fw-800">Artifact</div>
          <app-file-list
            [skipApiCallOnDelete]="true"
            [fileList]="[currentFeedback.attachment]"
            [hideDeleteButton]="true"
            [hideDownloadButton]="true" />
        </div>
      </ng-container>
      <ng-container *ngIf="currentFeedback.full_request.submission">
        <div class="mb-4">
          <div class="fw-800 mb-2">Additional Context</div>
          <app-safehtml [html]="currentFeedback.full_request.submission" />
        </div>
      </ng-container>
    </div>

    <div class="feedback-header mb-3">
      <img src="/assets/stars-pink.svg" class="me-2" alt="Ai Stars" />Smart
      Feedback
    </div>

    <div class="p-2">
      <ng-container
        *ngIf="currentFeedback.error && currentFeedback.error.length > 0">
        <div class="fw-800 color-danger">Error</div>
        <markdown [data]="currentFeedback.error"></markdown>
      </ng-container>
      <ng-container
        *ngIf="
          currentFeedback.strengths && currentFeedback.strengths.length > 0
        ">
        <div style="color: #430089" class="fw-800">Strengths</div>
        <markdown [data]="currentFeedback.strengths"></markdown>
      </ng-container>
      <ng-container
        *ngIf="
          currentFeedback.suggestions && currentFeedback.suggestions.length > 0
        ">
        <div class="fw-800 color-level-3">Suggestions</div>
        <markdown [data]="currentFeedback.suggestions"></markdown>
      </ng-container>
      <ng-container
        *ngIf="
          currentFeedback.improvements &&
          currentFeedback.improvements.length > 0
        ">
        <div class="fw-800 color-level-1">Next Steps</div>
        <markdown [data]="currentFeedback.improvements"></markdown>
      </ng-container>
      <ng-container
        *ngIf="currentFeedback.examples && currentFeedback.examples.length > 0">
        <div class="fw-800 color-level-2">Examples</div>
        <markdown>{{ currentFeedback.examples }}</markdown>
      </ng-container>
    </div>

    <div
      class="user-feedback d-flex justify-content-center align-items-center pb-4">
      <button class="btn-reset" (click)="copySmartFeedback()" ngbTooltip="Copy">
        <ng-container *ngIf="!copiedStatus; else checkIcon"
          ><i class="bi bi-copy"></i
        ></ng-container>
        <ng-template #checkIcon>
          <i class="bi bi-check2"></i>
        </ng-template>
      </button>
      <ng-container
        *ngIf="
          currentFeedback.user_feedback &&
            currentFeedback.user_feedback !== null;
          else addFeedback
        ">
        <ng-container
          *ngIf="currentFeedback.user_feedback === 'thumbs_up'; else upbutton">
          <div class="px-2">
            <i class="bi bi-hand-thumbs-up-fill"></i>
          </div>
        </ng-container>
        <ng-template #upbutton>
          <button
            class="btn-reset"
            (click)="submitUserFeedback(currentFeedback.id, 'thumbs_up')"
            ngbTooltip="Good Response">
            <i class="bi bi-hand-thumbs-up"></i>
          </button>
        </ng-template>

        <ng-container
          *ngIf="
            currentFeedback.user_feedback === 'thumbs_down';
            else downbutton
          "
          ><div class="px-2"><i class="bi bi-hand-thumbs-down-fill"></i></div>
        </ng-container>
        <ng-template #downbutton>
          <button
            class="btn-reset"
            (click)="submitUserFeedback(currentFeedback.id, 'thumbs_down')"
            ngbTooltip="Bad Response">
            <i class="bi bi-hand-thumbs-down"></i>
          </button>
        </ng-template>
      </ng-container>
      <ng-template #addFeedback>
        <button
          class="btn-reset"
          (click)="submitUserFeedback(currentFeedback.id, 'thumbs_up')"
          ngbTooltip="Good Response">
          <i class="bi bi-hand-thumbs-up"></i>
        </button>
        <button
          class="btn-reset"
          (click)="submitUserFeedback(currentFeedback.id, 'thumbs_down')"
          ngbTooltip="Bad Response">
          <i class="bi bi-hand-thumbs-down"></i>
        </button>
      </ng-template>
    </div>
  </div>
</app-modal>
